import { useMemo } from 'react';
import { getCrossPromo } from '../lib/crossPromo.js';

/**
 * CrossPromo — the small gradient block at the bottom of every tool page,
 * just above the footer. Rotates content per page load.
 *
 * Props:
 *   currentSlug: which tool we're on, e.g. "gradecalc". So we don't promote
 *     the current tool to itself.
 *   accent: primary brand color hex (e.g. "#14B8A6" for GradeCalc)
 *   accent2: secondary brand color for the gradient (e.g. "#5EEAD4")
 *   accentLight: a lighter version for the title text (e.g. "#A5B4FC")
 *
 * Visual matches the existing hardcoded blocks in each tool — gradient pill
 * with brand-colored border, title line, description line.
 */
export function CrossPromo({ currentSlug, accent, accent2, accentLight }) {
  // useMemo with empty deps → picks once per page load. Stable across re-renders.
  const { title, sentence } = useMemo(() => getCrossPromo(currentSlug), []);

  // Construct gradient with alpha from accent colors. The hex8 trick: append
  // "0F" for ~6% opacity, "1F" for ~12% opacity.
  const bgGradient = `linear-gradient(135deg, ${accent}10, ${accent2 || accent}10)`;
  const borderColor = `${accent}1F`;

  return (
    <div style={{
      marginTop: 32,
      padding: '20px',
      borderRadius: 16,
      background: bgGradient,
      border: `1px solid ${borderColor}`,
      textAlign: 'center',
    }}>
      <div style={{
        fontSize: 14,
        fontWeight: 600,
        color: accentLight || accent,
        marginBottom: 6,
      }}>
        {title}
      </div>
      <div style={{
        fontSize: 13,
        color: '#6B7280',
        lineHeight: 1.5,
      }}>
        {sentence}
      </div>
    </div>
  );
}
